import { Component, inject, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ManagementApiService } from '../../../../../../services';
import { PlantmanagerService } from '../../services/plantmanager.service';
import { AddTaggedItemModalComponent } from '../add-tagged-item-modal/add-tagged-item-modal.component';
import { ConnectorChild, PlantList } from '../../models/plant-manager.model';
import { TranslocoService } from '@jsverse/transloco';
import { DynamicControlsComponent } from 'src/app/Modules/management/components/modals/organization/dynamic-controls/dynamic-controls.component';
import { PageType } from 'src/app/Modules/idms/enums/PageType';
import { CustomToastService } from 'src/app/services/custom-toast.service';

@Component({
    selector: 'app-tagged-item-create',
    templateUrl: './tagged-item-create.component.html',
    styleUrls: ['./tagged-item-create.component.scss'],
    standalone: false,
})
export class TaggedItemCreateComponent {
    private modalService = inject(NgbModal);
    @Input() selectedTaggedItem: PlantList;
    @Input() ConnectorChildrenList: ConnectorChild[];

    tooltip_position = 'above';
    closeResult: string;
    matrixAddFormGroup: UntypedFormGroup;
    isAddEnabled: boolean;
    lblAddNewItem: String = this.transLocoService.translate(`PLANT_MANAGER.AddNewItem`);
    lblAdd: String = this.transLocoService.translate(`PLANT_MANAGER.Add`);

    constructor(
        private transLocoService: TranslocoService,
        // private modalService: NgbModal,
        private activeModal: NgbActiveModal,
        private plantmanagerServiceser: PlantmanagerService,
        private managementApiService: ManagementApiService,
        private customToastService: CustomToastService
    ) {}

    open(type?: ConnectorChild) {
        if (this.plantmanagerServiceser.activeTaggedItem) {
            if (type) {
                let dialogRef = this.modalService.open(AddTaggedItemModalComponent, {
                    ariaLabelledBy: 'modal-basic-title',
                    backdrop: 'static',
                    size: 'md',
                    keyboard: false,
                });
                dialogRef.componentInstance.selectedConnectorChild = type;
            }
        } else {
            //For Area or Root tagged item
            let schemaVersionId = type.schemaVersionId;

            this.managementApiService
                .GetSchemaVersions(schemaVersionId, localStorage.getItem('currentInstanceId'))
                .toPromise()
                .then((res) => {
                    if (res.success) {
                        this.OpenDynamicComponent(res.response.schema, type);
                    } else {
                        this.customToastService.errorToast(res?.message || this.transLocoService.translate(`PLANT_MANAGER.ErrorWhileReceiveData`), 'Error');
                    }
                })
                .catch((e) => {
                    console.warn(e);
                });
        }
    }

    OpenDynamicComponent(jsonString: string, type: ConnectorChild) {
        let dialogRef = this.modalService.open(DynamicControlsComponent, {
            size: 'lg',
        });

        dialogRef.componentInstance.jsonString = jsonString;
        dialogRef.componentInstance.selectedConnectorChild = type;
        dialogRef.componentInstance.mode = 'pop-up';
        dialogRef.componentInstance.pagetitle = type.taggedItemType
            ? this.transLocoService.translate(`PLANT_MANAGER.Create`) + ' ' + type.taggedItemType
            : this.transLocoService.translate(`PLANT_MANAGER.CreateTaggedItem`);
        dialogRef.componentInstance.PageType = PageType.PlantManagerCreate;
        dialogRef.componentInstance.permission = true;
        dialogRef.result
            .then((ObjSave: any = []) => {})
            .catch((error) => {
                console.warn(error);
            });
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    handle(e) {}
}
